import { WizardStep } from '@factorialco/deprecated-design-system'

import integrationCodes from 'modules/marketplace/lib/integrationCodes'
import { useA3InnuvaSteps } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/Steps'
import { A3InnuvaWizardData } from 'modules/payroll_integrations_a3innuva/lib/types'
import { useDatevLaudsSteps } from 'modules/payroll_integrations_datev_lauds/components/SettingsSteps/Steps'
import { DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

export const useSettingsSteps = (integrationId: string) => {
  const settingsMap = new Map<
    string,
    (() => WizardStep<A3InnuvaWizardData>)[] | (() => WizardStep<DatevWizardData>)[]
  >([
    [integrationCodes.a3innuva, useA3InnuvaSteps()],
    [integrationCodes.datev_lauds_factorial, useDatevLaudsSteps()],
  ])

  return (settingsMap.get(integrationId) || []).map((component) => component())
}
